module.exports = __webpack_public_path__ + "img/D202009_3.70abb0b1.jpg";